/* Krampus recipes: spirit filter + ingredient search, kept in the URL (?spirit=…&q=…). */
(function () {
  var root = document.querySelector('[data-kh-recipe-tools]');
  if (!root) return;
  var page = root.closest('.kh-journal') || document;
  var cards = Array.prototype.slice.call(page.querySelectorAll('.journal-card'));
  var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-spirit]'));
  var input = root.querySelector('[data-kh-recipe-search]');
  var clear = root.querySelector('[data-kh-recipe-clear]');
  var status = root.querySelector('[data-kh-recipe-status]');
  var empty = page.querySelector('[data-kh-recipe-empty]');
  var emptyText = page.querySelector('[data-kh-recipe-empty-text]');
  var reset = page.querySelector('[data-kh-recipe-reset]');
  var LABELS = {};
  buttons.forEach(function (b) { LABELS[b.dataset.spirit] = b.childNodes[0].textContent.trim(); });
  var KEY = 'kh:recipes:last';

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’'‘]/g, '').replace(/[^a-z0-9%½¼¾]+/g, ' ').trim();
  }
  cards.forEach(function (c) { c._kh = norm(c.dataset.search || c.textContent); c._sp = (c.dataset.spirits || '').split(/\s+/); });

  var state = { spirit: 'all', q: '' };

  function readUrl() {
    var p = new URLSearchParams(location.search);
    var s = p.get('spirit') || 'all';
    state.spirit = LABELS[s] ? s : 'all';
    state.q = p.get('q') || '';
  }
  function writeUrl(push) {
    var p = new URLSearchParams(location.search);
    if (state.spirit !== 'all') p.set('spirit', state.spirit); else p.delete('spirit');
    if (state.q.trim()) p.set('q', state.q.trim()); else p.delete('q');
    var qs = p.toString();
    var url = location.pathname + (qs ? '?' + qs : '') + location.hash;
    if (url !== location.pathname + location.search + location.hash) history[push ? 'pushState' : 'replaceState'](null, '', url);
    try { sessionStorage.setItem(KEY, location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
  }
  function render() {
    var terms = norm(state.q).split(' ').filter(Boolean);
    var shown = 0;
    cards.forEach(function (c) {
      var okSpirit = state.spirit === 'all' || c._sp.indexOf(state.spirit) !== -1;
      var okText = terms.every(function (t) { return c._kh.indexOf(t) !== -1; });
      c.hidden = !(okSpirit && okText);
      if (!c.hidden) shown++;
    });
    buttons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.spirit === state.spirit)); });
    if (input.value !== state.q) input.value = state.q;
    var active = state.spirit !== 'all' || state.q.trim() !== '';
    clear.hidden = !active;
    var parts = [];
    if (state.spirit !== 'all') parts.push('spirit: <strong>' + esc(LABELS[state.spirit]) + '</strong>');
    if (state.q.trim()) parts.push('search: <strong>“' + esc(state.q.trim()) + '”</strong>');
    status.innerHTML = 'Showing <strong>' + shown + '</strong> of ' + cards.length + ' recipes' + (parts.length ? ' · ' + parts.join(' · ') : '');
    if (empty) {
      empty.hidden = shown > 0;
      if (shown === 0 && emptyText) {
        emptyText.textContent = state.q.trim()
          ? 'No ' + (state.spirit !== 'all' ? LABELS[state.spirit] + ' ' : '') + 'recipes match “' + state.q.trim() + '”.'
          : 'No ' + LABELS[state.spirit] + ' recipes to show yet.';
      }
    }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () { state.spirit = b.dataset.spirit; render(); writeUrl(true); });
  });
  var t;
  input.addEventListener('input', function () {
    state.q = input.value; render();
    clearTimeout(t); t = setTimeout(function () { writeUrl(false); }, 300);
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { e.preventDefault(); state.q = ''; render(); writeUrl(false); } });
  function resetAll(focusInput) { state.spirit = 'all'; state.q = ''; render(); writeUrl(true); (focusInput ? input : buttons[0]).focus(); }
  clear.addEventListener('click', function () { resetAll(false); });
  if (reset) reset.addEventListener('click', function () { resetAll(true); });
  window.addEventListener('popstate', function () { readUrl(); render(); });

  readUrl(); render(); writeUrl(false);
})();
